import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { Button, Grid, Row, Col } from 'react-bootstrap'
import { translate } from '../../../common/utils'
import { createDeliveries } from '../../DataAnalytics/redux/dataAnalyticsActions'
import { swalInfo } from '../../../common/components/Swaler'

const styles = {
    content: {
        top: '25%',
        left: '10%',
        bottom: '5%',
        right: '10%'
    }
}

const inputFields = [
    { key: 'carrierInternalOrderId', desc: 'Ert interna order-id' },
    { key: 'street', desc: 'Gatuadress till enheten' },
    { key: 'phone', desc: 'Mottagarens telefonnummer' },
    { key: 'vendorName', desc: 'Avsändarnamn' },
    { key: 'driverPhone', desc: 'Chaufförs telefonnummer, det kommer skickas ut ett SMS till denne' }
]

class CreateDeliveryModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalIsOpen: false,
            input: {}
        }

        this.closeModal = this.closeModal.bind(this)
        this.saveDelivery = this.saveDelivery.bind(this)
    }

    closeModal() {
        this.props.closeModal()
    }

    saveDelivery() {
        this.props.createDeliveries([this.state.input]).then(t => {
            const data = t.data
            swalInfo("Klart!", null, `${data.result}  \n ${data.errors.length ? "Servern svarade med felmeddelande: " + data.errors.join(',') : ''}`)
        }).catch(e => {
            console.log(e)
        })
    }

    render() {
        if (!this.props.modalIsOpen) return null

        return (
            <Modal
                ariaHideApp={false}
                isOpen={this.props.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={styles}
                contentLabel="E">
                <button onClick={this.closeModal}>Stäng</button>

                <hr />

                <Grid>

                    {inputFields.map(field => {
                        return (
                            <Row key={field.key}>
                                <Col xs={2} md={2} lg={2}>
                                    {translate(field.key)}:
                                </Col>
                                <Col xs={6} md={6} lg={6}>
                                    <div className="input-group">
                                        <input
                                            className="change-input form-control"
                                            value={this.state.input[field.key]}
                                            type="text"
                                            onChange={(e) => this.setState({ input: { ...this.state.input, [field.key]: e.target.value } })}
                                        />
                                    </div>
                                    <br />
                                </Col>
                                <Col xs={4} md={4} lg={4}>
                                    {field.desc}
                                </Col>
                            </Row>
                        )
                    })}
                    <Button className="save-settings-btn" type="submit" onClick={this.saveDelivery}>
                        Skapa leverans
                    </Button>


                </Grid>

            </Modal >
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatch = (dispatch) => ({
    createDeliveries: (deliveries) => dispatch(createDeliveries(deliveries)),
})

export default connect(mapStateToProps, mapDispatch)(CreateDeliveryModal)